<template>
  <el-button :type="type" v-bind="$attrs" v-on="$listeners" :icon="icon">
    删除
  </el-button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'danger'
    },
    icon: {
      type: String,
      default: 'fa fa-fw fa-trash'
    }
  },
  methods: {}
}
</script>
